<template>
  <v-app id="app">
    <router-view/>
  </v-app>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style lang="less">

body {
  margin: 0;
}

#app {
  font-family: "Libre Franklin", "Helvetica Neue", helvetica, arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333333;
  margin: 0;

  h1 {
    a {
      color: #fff;
      transition: opacity 0.2s;
      opacity: 1;
      text-decoration: none;
      &:hover {
        opacity: 0.7;
      }
    }
  }

  h2, h3 {
    font-size: 0.875rem;
    font-weight: 800;
    letter-spacing: 0.14em;
    text-transform: uppercase;
  }

  p, address {
    color: #333;
    font-size: 1rem;
    line-height: 1.5;
    font-style: normal;
    margin: 0 0 1.5em;
  }

  .v-gallery .light-carousel {
    background-color: transparent;
  }
}

</style>
